import styled, { css } from 'styled-components';
import { colors, media, layout, remCalc } from '@prisjakt/ui-base';
import AdContainer from '../../../../components/ads';

const compensateForPadding = layout.gridColumnGutter.small.rem / 2;

export const Empty = styled.section`
  margin-top: ${layout.margins.component.desktop.rem};
  width: 100%;
  a {
    display: block;
    margin-top: 1rem;
    text-decoration: underline;
  }

  ul {
    padding-left: 40px;
  }
`;

export const Container = styled.div`
  div:empty,
  a:empty {
    height: 0;
    padding: 0 !important;
    border-bottom: 0 !important;
  }
`;

export const ProductCount = styled.div`
  display: none;

  ${media.smallOnly`
    display: flex;
    justify-content: center;
    color: ${colors.darkGray4};
    padding: ${remCalc(10, 0, 5, 0)};
  `}
`;

export const SearchField = styled.div`
  display: none;
  width: 100%;

  ${props =>
    props.show &&
    css`
      display: block;
    `}
`;

export const Panel = styled.div``;

export const Ad = styled(AdContainer)`
  margin-top: 5px;
  margin-bottom: 5px;

  &:empty {
    display: none;
  }

  ${props =>
    props.mobilePosition &&
    css`
      ${Panel} && {
        width: 100%;
        order: 10;

        @media screen and (max-width: 1023px) {
          order: 13;
        }
        @media screen and (max-width: 824px) {
          order: 10;
        }
        @media screen and (max-width: 639px) {
          order: 11;
        }
        @media screen and (max-width: 608px) {
          order: 11;
        }
        @media screen and (max-width: 607px) {
          order: 12;
        }
        @media screen and (max-width: 491px) {
          order: 9;
        }
        @media screen and (max-width: 340px) {
          > iframe {
            margin-left: ${compensateForPadding};
            margin-right: ${compensateForPadding};
          }
        }
      }
    `}

  ${props =>
    props.panoramaPosition &&
    css`
      ${Panel} && {
        max-width: 100%;
        order: 9;
        @media screen and (max-width: 1023px) {
          order: 11;
        }
        @media screen and (max-width: 823px) {
          order: 11;
        }
        @media screen and (max-width: 822px) {
          order: 9;
        }
      }
    `}
`;
